import { useRef } from 'react'

import { htmlToPlainText, useTextOverflow } from '@percent/utility'
import { RichDescription, Text, Tooltip } from '@percent/lemonade'
import classes from './GivingActionCard.module.scss'

export function GivingActionCardTitle({
  name,
  onClick,
  testId
}: Readonly<{ name: string; onClick: VoidFunction; testId: string }>) {
  const nameRef = useRef<HTMLSpanElement>(null)
  const isOverflowing = useTextOverflow(nameRef, 'vertical')

  return (
    <button type="button" className={classes.TitleButton} onClick={onClick} data-testid={testId}>
      <Tooltip content={isOverflowing ? name : ''} placement="top">
        <span ref={nameRef} className={classes.Title}>
          <Text fontWeight="medium">{name}</Text>
        </span>
      </Tooltip>
    </button>
  )
}

export function GivingActionCardDescription({ description }: Readonly<{ description: string }>) {
  const descriptionRef = useRef<HTMLDivElement>(null)
  const isOverflowing = useTextOverflow(descriptionRef, 'vertical')

  return (
    <Tooltip content={isOverflowing ? htmlToPlainText(description) : ''} placement="top">
      <div ref={descriptionRef} className={classes.Description}>
        <RichDescription content={description} />
      </div>
    </Tooltip>
  )
}
